export default __webpack_public_path__ + "static/testimonial-user-2-4122486449750fd99092bdaedb6b5aca.jpg";